/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { Select } from 'antd';
import styles from './styles.module.scss';
import styled from 'styled-components';

interface OptionListPropsString {
  optionList: { [key: string]: number };
  width: number;
  placeHolder: string;
  setValue: any;
  defaultValue?: any;
  className?: any;
  disabled?: boolean;
  iconColor?: string;
  dropDownBackground?: string;
}

interface OptionListPropsNumber {
  optionList: Array<number>;
}
const StyledSelect = styled(Select)`
  .ant-select-selector {
    // background-color: #f6f7fc !important;
    border: none !important;
  }
  .ant-select-dropdown {
    scroll-behavior: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }
`;
export const SelectStringInput: React.FC<OptionListPropsString> = ({
  optionList,
  width,
  placeHolder,
  setValue,
  defaultValue,
  className,
  disabled,
  iconColor,
  dropDownBackground,
}: OptionListPropsString): JSX.Element => {
  useEffect(() => {
    console.log(optionList);
  }, [optionList]);
  return (
    <>
      <StyledSelect
        onChange={(e) => {
          console.log(e);
          return setValue(e);
        }}
        className={className}
        showSearch
        dropdownStyle={{
          background: dropDownBackground ? dropDownBackground : '',
        }}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        dropdownMatchSelectWidth={true}
        suffixIcon={
          <>
            <img src="/expand_more.png" />
          </>
        }
        disabled={disabled ? true : false}
        defaultValue={defaultValue}
        style={{
          width: width,
          // background: '#d5d5d5 !important',
          marginBottom: '10px',
          borderRadius: '6px',
        }}
        placeholder={placeHolder}
        optionFilterProp="children"
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        options={Object.keys(optionList).map((key) => ({
          value: optionList[key],
          label: key,
        }))}
      />
    </>
  );
};

export const SelectNumberInput: React.FC<OptionListPropsNumber> = ({
  optionList,
}: OptionListPropsNumber): JSX.Element => {
  return (
    <>
      <Select
        defaultValue="1"
        style={{ width: 100, background: 'white' }}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange={() => { }}
        options={optionList.map((item) => ({ value: item, label: item }))}
      />
    </>
  );
};
